module.exports = __webpack_public_path__ + "img/transactions.c9a4d5ef.svg";